import { memo } from "react";
import { Pressable } from "react-native";
import { useAppTheme } from "../useAppTheme";

const SheetHandle = ({
	onPress,
	backgroundColor,
}: {
	onPress?: () => void;
	backgroundColor?: string;
}) => {
	const theme = useAppTheme();

	return (
		<Pressable
			onPress={onPress}
			style={({ pressed, hovered }) => ({
				borderRadius: 4,
				backgroundColor:
					pressed || hovered
						? theme.colors.backdrop
						: (backgroundColor ?? theme.colors.surfaceDisabled),
				width: 72,
				height: 6,
				overflow: "hidden",
				alignSelf: "center",
				marginTop: 8,
				marginBottom: 8,
			})}
		/>
	);
};

export default memo(SheetHandle);
